import locale from "@/helpers/locale";
import moment from "moment";

export const monthlyClosingThead = () => {
  return [
    {
      label: locale("monthlyClosing.th.theaterName"),
      prop: "cinemaBrandName",
      apiProp: "cinemaBrandName",
      align: "center",
    },
    {
      label: locale("monthlyClosing.th.month"),
      prop: "month",
      apiProp: "month",
      align: "center",
    },
    {
      label: locale("monthlyClosing.th.accountName"),
      prop: "operationName",
      apiProp: "operationName",
      align: "center",
    },
    {
      label: locale("monthlyClosing.th.closingTime"),
      prop: "createTime",
      apiProp: "createTime",
      align: "center",
    },
    {
      label: locale("monthlyClosing.th.status"),
      prop: "status",
      apiProp: "status",
      align: "center",
    }
  ];
};

export const formatData = (originalArr => {
  let newArr = [], notApprove = false;
  originalArr.map(item => {
    let obj = {};

    obj.id = item.id;
    obj.cinemaBrandName = item.cinemaBrandName;
    obj.month = moment(item.monthString).format("YYYY/MM");
    obj.operationName = item.operationName;
    obj.createTime = moment(item.createTime).format("YYYY/MM/DD HH:mm:ss");
    obj.approve = item.approve;
    obj.canDelete = item.canDelete;
    obj.status = item.status === "delete" ? locale("monthlyClosing.deleted") : "";

    newArr.push(obj);
  });

  notApprove = originalArr.some(item => item.approve === false);

  return {
    notApprove: notApprove,
    tableData: newArr,
  };
});